export const urlMaker = path => {
  return `/${path.split("/")[path.split("/").length - 2]}/${
    path.split("/")[path.split("/").length - 1].split(".")[0]
  }`
}
